<div class="header" *transloco="let i18n">
    <div class="header__left">
        <div class="header__open-menu" (click)="openMenu()">
            <lib-svg-icon [icon]="SvgIcons.MENU" color="var(--common-text-color)"></lib-svg-icon>
        </div>
    </div>
    <div class="header__right">
        <div class="header__profile-menu" [matMenuTriggerFor]="profileMenu">
            @if (account()) {
                <div>{{ account()?.username }}</div>
                <lib-svg-icon [icon]="SvgIcons.CHEVRON_BOTTOM" color="var(--common-text-color)"></lib-svg-icon>
            }
        </div>
        <mat-menu #profileMenu="matMenu" xPosition="before">
            <button mat-menu-item (click)="logout()">
                <div class="header__profile-menu-item">
                    <lib-svg-icon [icon]="SvgIcons.EXIT" color="var(--common-error-color)"></lib-svg-icon>
                    <div>{{ i18n('app.App.UserMenu.Exit') }}</div>
                </div>
            </button>
        </mat-menu>
    </div>
</div>
